const modalButton = {
  render({ type, text, icon, url }) {
    if (!type) {
      return
    }
    return `<a href="${url}" class="modal__button button button--${type}" target="_blank">
      ${icon ? `<span class="button__icon">${icon}</span>` : ''}
      <span class="button__text">${text}</span>
    </a>`
  },
}

export default modalButton
